<template>
    <div>
        <ul class="nav_case">
            <li :class="btn_index == item.path ? 'active' : ''" v-for="(item, index) in btnList" :key="index" @click="onClick(item, index)">{{item.name}}</li>
        </ul>
    </div>
</template>

<script>
    import { mapState } from "vuex"

    export default {
        name: "navTab",
        data() {
            return {
                btn_index: this.$route.path,

            }
        },
        computed: {
            ...mapState(["command"]),

            btnList() {
                let arr = [
                    {name: "预约管理", path: "/workPlat"},
                ]
                let arr_ = [
                    {name: "人员管理", path: "/staff"},
                    {name: "单位管理", path: "/unit"},
                    {name: "假期管理", path: "/vacation"},
                    {name: "预约时间管理", path: "/time"},
                    {name: "统计管理", path: "/count"},
                    {name: "登录日志", path: "/log-management/loginLog"},
                ]
                if(this.command == '超级管理员' || this.command == '高级管理员') {
                    return arr.concat(arr_);
                } else {
                    return arr;
                }
            },

        },
        watch: {
			command(newV) {
				console.log(newV)
				if(newV != "超级管理员" || newV != "高级管理员") {
					this.$router.push("/workPlat");
				}
			},

		},
        mounted() {
            
        },
        methods: {
            onClick(e, index) {
                this.$router.push(`${e.path}`);
            },

        }
    }
</script>

<style lang="scss" scoped>
    .nav_case {
        margin: 20px auto;
        display: flex;
    }
    .nav_case li {
        padding: 5px 10px;
        text-align: center;
        font-size: 15px;
        cursor: pointer;
    }
    .active {
        background: rgb(157, 197, 240);
        color: rgb(6, 135, 241);
    }
</style>


// WEBPACK FOOTER //
// navTab.vue?909205f6